module.exports = __webpack_public_path__ + "static/media/loading.09cfe256.svg";